// #583 S6a — how the audit screens word an entry's fields. Every value is rendered as text by the
// caller; nothing here produces markup or a route.
export const NOT_RECORDED = 'Not recorded';

/** An instant as `YYYY-MM-DD HH:MM:SS UTC`; an unparseable value is shown as the server sent it. */
export function formatUtc(value) {
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? String(value) : `${d.toISOString().slice(0, 19).replace('T', ' ')} UTC`;
}

export function actorText(actor) {
  if (!actor) return NOT_RECORDED;
  const name = actor.displayName || actor.id || NOT_RECORDED;
  return actor.email ? `${name} (${actor.email})` : name;
}

export function targetText(target) {
  if (!target || (!target.type && !target.id)) return NOT_RECORDED;
  return [target.type, target.id].filter(Boolean).join(' ');
}

export const orNotRecorded = (value) => (value === null || value === undefined || value === '' ? NOT_RECORDED : String(value));

/** A datetime-local value, read as UTC, as the exact ISO instant the schema requires. */
export function utcInstant(value) {
  const d = new Date(`${value}Z`);
  return Number.isNaN(d.getTime()) ? value : d.toISOString();
}

// The shapes server/schemas/platform-audit.schemas.js accepts (Zod 4's uuid, `^[a-z_.]+$`, the
// length caps). A value it can only refuse is named here and never sent: a refused query retried
// as-is fails forever.
const UUID = /^([0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|0{8}-0{4}-0{4}-0{4}-0{12}|f{8}-f{4}-f{4}-f{4}-f{12})$/i;
const LOCAL_TIME = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2}(\.\d{1,3})?)?$/;
const isTime = (v) => {
  if (!LOCAL_TIME.test(v)) return false;
  const normalized = utcInstant(v);
  // Date normalizes impossible days. Require a round trip of every supplied calendar field.
  const exact = v.length === 16 ? `${v}:00.000Z`
    : v.includes('.') ? `${v.padEnd(23, '0')}Z` : `${v}.000Z`;
  return normalized !== v && normalized === exact;
};
const FILTER_RULES = {
  q: [(v) => v.length <= 200, 'at most 200 characters'],
  adminId: [(v) => UUID.test(v), 'a UUID'],
  tenantId: [(v) => UUID.test(v), 'a UUID'],
  action: [(v) => v.length <= 100 && /^[a-z_.]+$/.test(v), 'lowercase letters, dots and underscores'],
  from: [isTime, 'a date and time'],
  to: [isTime, 'a date and time'],
};

/** The first filter the server would refuse, as [key, what it must be], or null. */
export function invalidFilter(filters) {
  for (const [key, [ok, must]] of Object.entries(FILTER_RULES)) {
    const value = typeof filters[key] === 'string' ? filters[key].trim() : '';
    if (value && !ok(value)) return [key, must];
  }
  const [from, to] = [filters.from.trim(), filters.to.trim()];
  return from && to && !(utcInstant(from) < utcInstant(to)) ? ['to', 'after From'] : null;
}
